import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Stack,
  Typography,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import store from "../../store";
import { getPharmacyInformation, getCustomerInfo } from "../../server/axios";
import { Header, Loading, MainColorButton } from "../../components";
import {
  rowRightBottomButtonScroll,
  rowLeftBottomButtonScroll,
} from "../../common/styles";
import { Link } from "react-router-dom";
import {
  PRESCRIPTION_TYPE_SELECTOR,
  IS_NEW_PHARMACY_SELECTOR,
  PHARMACY_SELECTOR,
} from "../../routes/path";
import { setApplyPrescriptionInfo } from "../../store/actions/prescription";

/**
 * 薬局情報表示
 * @returns
 */
const PharmacyInformation = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const pharmacySelectedState = (state) => state.prescription.pharmacySelected;
  let pharmacySelected = pharmacySelectedState(store.getState());

  const selectLineInfo = (state) => state.prescription.lineInfo;
  let lineInfo = selectLineInfo(store.getState());

  const [loadingOpen, setLoadingOpen] = useState(false);
  const [showRequestBtn, setShowRequestBtn] = useState(false);

  //初期データ
  const [tenantInfo, setTenantInfo] = useState({
    tenantId: "",
    tenantName: "",
    addressCity: "",
    address1: "",
    address2: "",
    phoneNumber: "",
    faxNumber: "",
    prescription: [],
    prescriptionNameList: [],
  });

  const [locationInfo, setLocationInfo] = useState({
    locationId: "",
    locationName: "",
    locationAddress: "",
  });

  const [businessWeekInfoList, setBusinessWeekInfoList] = useState([]);

  useEffect(() => {
    setLoadingOpen(true);

    Promise.allSettled([
      getPharmacyInformation({
        tenantId: pharmacySelected.selectedRows.tenantId,
        locationId: pharmacySelected.selectedRows.locationId,
        prescription: pharmacySelected.selectedRows.prescription,
        lineId: lineInfo.lineId,
      }),
      getCustomerInfo({ lineId: lineInfo.lineId }),
    ]).then((results) => {
      const res = results[0].value;
      setTenantInfo({
        tenantId: res.data.target.tenantId,
        tenantName: res.data.target.tenantName,
        addressCity: res.data.target.addressCity,
        address1: res.data.target.address1,
        address2: res.data.target.address2,
        phoneNumber: res.data.target.phoneNumber,
        faxNumber: res.data.target.faxNumber,
        prescription: res.data.target.prescription,
        prescriptionNameList: res.data.target.prescriptionNameList,
      });

      setLocationInfo({
        locationId: res.data.target.locationId,
        locationName: res.data.target.locationName,
        locationAddress: res.data.target.locationAddress,
      });

      setBusinessWeekInfoList(res.data.target.businessWeekInfoList);

      const res2 = results[1].value;
      setShowRequestBtn(!res2.data.isNew);

      setLoadingOpen(false);
    });
  }, []);

  // 申込実行
  function handleClick() {
    const applyPrescriptionInfo = {
      tenantId: tenantInfo.tenantId,
      locationId: locationInfo.locationId,
    };
    store.dispatch(setApplyPrescriptionInfo(applyPrescriptionInfo));

    const customerSelectedByState = (state) =>
      state.prescription.customerSelected;
    let customerSelected = customerSelectedByState(store.getState());

    if (customerSelected) {
      navigate(PRESCRIPTION_TYPE_SELECTOR, {
        state: {
          prescription: tenantInfo.prescription,
          week: businessWeekInfoList,
        },
      });
    } else {
      navigate(IS_NEW_PHARMACY_SELECTOR);
    }
  }

  return (
    <>
      <Loading open={loadingOpen} />
      <div
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <Header title="薬局情報" />
        <Box
          sx={{ height: "76vh", overflowY: "scroll" }}
          marginTop="11vh"
          width="90%"
          marginLeft="auto"
          marginRight="auto"
        >
          <Stack>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack
                width="35%"
                direction="column"
                justifyContent="space-between"
                spacing="12%"
              >
                <Typography>薬局名</Typography>
                <Typography>住所</Typography>
                <Typography>電話番号</Typography>
                <Typography>FAX</Typography>
                <Typography>処方箋種類</Typography>
              </Stack>
              <Box width="65%">
                <FormControl fullWidth>
                  <Paper elevation={0} variant="outlined" sx={{ border: 1 }}>
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              align="left"
                              padding="none"
                              sx={{ padding: "2.5%", height: "25px" }}
                            >
                              {tenantInfo.tenantName}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              align="left"
                              padding="none"
                              sx={{ padding: "2.5%", height: "25px" }}
                            >
                              {tenantInfo.addressCity}
                              {tenantInfo.address1}
                              {tenantInfo.address2}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              align="left"
                              padding="none"
                              sx={{ padding: "2.5%", height: "25px" }}
                            >
                              <a href={`tel:${tenantInfo.phoneNumber}`}>
                                {tenantInfo.phoneNumber}
                              </a>
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              align="left"
                              padding="none"
                              sx={{ padding: "2.5%", height: "25px" }}
                            >
                              {tenantInfo.faxNumber}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              align="left"
                              padding="none"
                              sx={{ padding: "2.5%", height: "25px" }}
                            >
                              {tenantInfo.prescriptionNameList.join("、")}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </FormControl>
              </Box>
            </Stack>
            <hr></hr>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack
                width="35%"
                direction="column"
                justifyContent="space-between"
                spacing="12%"
              >
                <Typography>受取ロッカー</Typography>
                <Typography>ロッカー所在地</Typography>
              </Stack>
              <Box width="65%">
                <FormControl fullWidth>
                  <Paper elevation={0} variant="outlined" sx={{ border: 1 }}>
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              align="left"
                              padding="none"
                              sx={{ padding: "2.5%", height: "25px" }}
                            >
                              {locationInfo.locationName}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              align="left"
                              padding="none"
                              sx={{ padding: "2.5%" }}
                            >
                              {locationInfo.locationAddress}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </FormControl>
              </Box>
            </Stack>

            <Typography marginTop="8%">営業情報</Typography>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Stack
                width="20%"
                marginLeft="5%"
                direction="column"
                justifyContent="space-between"
                spacing={1}
              >
                <Typography>日曜日</Typography>
                <Typography>月曜日</Typography>
                <Typography>火曜日</Typography>
                <Typography>水曜日</Typography>
                <Typography>木曜日</Typography>
                <Typography>金曜日</Typography>
                <Typography>土曜日</Typography>
              </Stack>
              <Box width="70%">
                <FormControl fullWidth>
                  <Paper elevation={0} variant="outlined" sx={{ border: 1 }}>
                    <TableContainer>
                      <Table>
                        <TableBody>
                          {businessWeekInfoList.map((item, index) => (
                            <TableRow key={index}>
                              <TableCell
                                align="center"
                                padding="none"
                                sx={{ padding: "2.5%" }}
                              >
                                {item.businessDayFlg
                                  ? `${(item.openTime || "").slice(0, -3)}~${(
                                      item.closeTime || ""
                                    ).slice(0, -3)}`
                                  : "休み"}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </FormControl>
              </Box>
            </Stack>
            <Stack marginTop={2} marginBottom={3}>
              <Link to="/specifiedCommercial">特定商取引法に基づく表記</Link>
            </Stack>
          </Stack>
        </Box>
        <MainColorButton
          label="戻る"
          onClick={() => {
            const { state } = location;
            const _pharmacy = state?.pharmacy;
            if (typeof _pharmacy === "undefined") {
              navigate(-1);
            } else {
              navigate(PHARMACY_SELECTOR, { state: { ...location.state } });
            }
          }}
          style={rowLeftBottomButtonScroll}
        />
        {showRequestBtn && (
          <MainColorButton
            label="申込"
            onClick={() => handleClick()}
            style={rowRightBottomButtonScroll}
          />
        )}
      </div>
    </>
  );
};

export default PharmacyInformation;
